import { RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

const CHECK_EVERY_MS = 15 * 60 * 1000;

/**
 * Avisa cuando el service worker tomó una versión nueva. Una pestaña abierta sigue
 * con la anterior hasta recargar, y recargar solo podría perder una venta en curso:
 * por eso decide el usuario.
 */
export function UpdateBanner() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    const sw = navigator.serviceWorker;
    if (!sw) return;
    // Sin controlador es la primera instalación: la página ya es la última versión.
    const hadController = Boolean(sw.controller);
    const onChange = () => {
      if (hadController) setAvailable(true);
    };
    const check = () => {
      void sw.getRegistration().then((registration) => registration?.update());
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    sw.addEventListener("controllerchange", onChange);
    document.addEventListener("visibilitychange", onVisible);
    const timer = window.setInterval(check, CHECK_EVERY_MS);
    return () => {
      sw.removeEventListener("controllerchange", onChange);
      document.removeEventListener("visibilitychange", onVisible);
      window.clearInterval(timer);
    };
  }, []);

  if (!available) return null;
  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-3 rounded-2xl bg-slate-900 py-2 pr-2 pl-4 text-sm font-semibold text-white shadow-xl print:hidden"
    >
      Hay una versión nueva
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="flex items-center gap-1.5 rounded-xl bg-brand-600 px-3 py-1.5 font-bold hover:bg-brand-500"
      >
        <RefreshCw className="h-4 w-4" /> Actualizar
      </button>
    </div>
  );
}
